import depositRequests from "./deposit-request";
import changeStatus from "./change-status";

const appsModule = {
  namespaced: true,
  modules: { depositRequests, changeStatus },
};

export default appsModule;
